import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import PropTypes from 'prop-types';
import Icon from './Icon';

export default function AlertDialog({
  open = false,
  handleClose = () => {},
  handleConfirm = () => {},
  text = 'Vill du verkligen göra det här?',
  cancelText = 'Nej',
  confirmText = 'Ja',
  confirmColor,
  confirmVariant,
  icon,
  iconColor
}) {
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {icon && (
              <Icon
                icon={icon}
                style={{ width: "1em", color: iconColor }}
                size="xl"
                color={iconColor}
              />
            )}{text}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {cancelText}
          </Button>
          <Button onClick={handleConfirm} variant={confirmVariant || "text"} color={confirmColor || "primary"} autoFocus>
            {confirmText}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

AlertDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  handleConfirm: PropTypes.func,
  text: PropTypes.string,
  cancelText: PropTypes.string,
  confirmText: PropTypes.string
};

/*AlertDialog.defaultProps = {
  open: false,
  handleClose: () => {},
  handleConfirm: () => {},
  text: 'Vill du verkligen göra det här?',
  cancelText: 'Nej',
  confirmText: 'Ja'
};
*/